var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Order, Ordered, Service } from 'preact-soa';
import { NetworkingLayer } from 'netlayer';
var NetworkingService = (function (_super) {
    __extends(NetworkingService, _super);
    function NetworkingService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = process.env.REACT_API_URL + '/api';
        _this.timeout = 5000;
        _this.internetDelay = 40;
        _this.defaultDriver = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var payload, headers, response, obj;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        payload = request.payload;
                        headers = request.headers;
                        if (headers['content-type'] === 'multipart/form-data') {
                            delete headers['content-type'];
                        }
                        else if (!headers['content-type']) {
                            headers['content-type'] = 'application/json';
                            payload = JSON.stringify(request.payload);
                        }
                        if (request.method === 'DELETE' || request.method === 'GET') {
                            payload = undefined;
                        }
                        return [4, fetch(this.baseUrl + request.url, {
                                method: request.method,
                                headers: headers,
                                redirect: 'follow',
                                body: payload,
                            })];
                    case 1:
                        response = _b.sent();
                        _a = {
                            status: response.status,
                            statusText: response.statusText
                        };
                        return [4, response.json()];
                    case 2:
                        obj = (_a.payload = _b.sent(),
                            _a);
                        if (response.status >= 400) {
                            throw obj;
                        }
                        return [2, obj];
                }
            });
        }); };
        _this.driver = _this.mockDRIVER(_this.defaultDriver);
        return _this;
    }
    NetworkingService = __decorate([
        Service,
        Order(Ordered.HIGHEST_PRECEDENCE)
    ], NetworkingService);
    return NetworkingService;
}(NetworkingLayer));
export { NetworkingService };
